import * as React from 'react';
import Services from "../../utilities/Services";
import axios from "axios";
import {getCurrentUser, isEmpty, logOut} from "../../utilities/Utilities";
import {notify} from "../../utilities/notify";
import InputMask from "react-input-mask";
import Req from "../Req";
import {Modal, Button, Form} from "react-bootstrap";
import {FormField, RequiredLegend, focusFirstInvalid, WYMAGANIA_HASLA} from "../sharedComponents/Forms";
//import {Simulate} from "react-dom/test-utils";
//import error = Simulate.error;

interface Props {
}

interface State {

    powNoweHaslo: any,
    noweHaslo: any,
    stareHaslo: any,
    oddzialy: any,
    user: any,
    isEdit: boolean,
    loading: boolean,
    zapisywanie: boolean,
    czyEdytowac: boolean,
    czyFirma: boolean,
    showUsunKonto: boolean,
    haslo: string,
    usuwanieKonta: boolean,
    bladNowegoHasla: string | null,
    bladPowtorzenia: string | null
}

export class Account extends React.Component<Props, State> {

    zmianaHaslaRef = React.createRef<HTMLDivElement>();

    constructor(props: any) {
        super(props);

        this.state = {
            user: {
                'login': '',
                'haslo': '',
                'nrIdent': '',
                'firma': '',
                'firma2': '',
                'miasto': '',
                'kodPocztowy': '',
                'kraj': 'PL'
            },
            oddzialy: [],
            stareHaslo: '',
            noweHaslo: '',
            powNoweHaslo: '',
            isEdit: false,
            loading: false,
            zapisywanie: false,
            czyEdytowac: false,
            czyFirma: false,
            showUsunKonto: false,
            haslo: '',
            usuwanieKonta: false,
            bladNowegoHasla: null,
            bladPowtorzenia: null
        }

    }

    componentDidMount() {
        this.pobierzKlient();

        // this.setState({
        //     username: getCurrentUser().data.username,
        //     adres: getCurrentUser().data.adres,
        //     adres2: getCurrentUser().data.adres2
        // });

        //alert(this.state.klient)
        //alert(axios.defaults.headers.common.Authorization)
    }

    pobierzOddzialy = () => {
        Services.getOddzialy()
            .then((response) => {
                if (response.status === 200) {

                    console.log("get Oddzialy ok");

                    this.setState({oddzialy: response.data.sort(
                            (a: any, b: any) => {
                                return a.adres.localeCompare(
                                    b.adres,
                                );
                            },
                        ).map((oddzial: any) => {return oddzial}), loading: false});

                }
            }).catch((error) => {
            this.setState({loading: false});
            console.log('get Oddzialy error');
        })
    }

    pobierzKlient = () => {
        this.setState({loading: true});

        //alert(axios.defaults.headers.common.Authorization)

        Services.getKlient(getCurrentUser().email)
            .then((response) => {
                if (response.status === 200) {

                    console.log("get Klient ok");

                    this.setState({user: response.data, isEdit: false, czyFirma: !isEmpty(response.data.nrIdent), loading: false});

                    // this.pobierzOddzialy();

                }
            }).catch((error) => {
            this.setState({loading: false});
            console.log('get Klient error');
        })
    }

    zmienHaslo = () => {
        this.setState({zapisywanie: true, bladNowegoHasla: null, bladPowtorzenia: null});

        const data = {
            'login': this.state.user.username,
            'newPassword': this.state.noweHaslo,
            'oldPassword': this.state.stareHaslo
        }

        if (this.state.noweHaslo === this.state.powNoweHaslo) {
            Services.SprawdzHaslo(this.state.noweHaslo).then((response) => {
                if (response.status === 200) {
                    this.zmienHasloService(data);
                }
            }).catch((error) => {
                const komunikat = (error.response && error.response.data.message) || 'Hasło nie spełnia wymagań.';
                this.setState({zapisywanie: false, bladNowegoHasla: komunikat}, () => focusFirstInvalid(this.zmianaHaslaRef.current));
                notify.error(komunikat, 'Błąd zmiany hasła');
            })
        } else {
            this.setState({zapisywanie: false, bladPowtorzenia: 'Hasła nie są identyczne.'}, () => focusFirstInvalid(this.zmianaHaslaRef.current));
            notify.error('', 'Hasła są różne');
        }
    }

    usunKonto = () => {
        this.setState({usuwanieKonta: true});
        let dane = {
            haslo: this.state.haslo
        }

        // console.log(dane)

        Services.UsunKontoKlienta(dane).then((response) => {
            this.setState({showUsunKonto: false, usuwanieKonta: false});
            setInterval(() => logOut(), 10500);
            notify.info('Aby dokończyć proces usuwania konta, kliknij w link wysłany na adres email przypisany do twojego konta.\n Za chwilę nastąpi wylogowanie.', 'Usuwanie konta');
            // logOut();
        }).catch((e) => {
            this.setState({usuwanieKonta: false});
            notify.error(e.response.data.message, 'Błąd');
        })
    }

    handleOnChange = (e: React.FormEvent<HTMLInputElement>) => {
        const {name, value}: any = e.target;
        let input = this.state.user;
        input[name]=value;
        this.setState({user: input, isEdit: true});
        console.log(name, value)
    };

    zmienHasloService = (data: any) => {
        this.setState({zapisywanie: true});

        Services.ZmianaHasla(data)
            .then((response) => {
                if (response.status === 200) {

                    //this.setState({onRegister: true, registerLoading: false})
                    console.log("Zmiana hasla ok");
                    notify.info("Pomyślnie zmieniono hasło do konta", 'Zmieniono hasło');

                    //@ts-ignore
                    let token = 'Basic ' + btoa(this.state.user.email + ':' + this.state.noweHaslo);
                    axios.defaults.headers.common.Authorization = token;
                    let sesionStorage = getCurrentUser();
                    sesionStorage['token'] = token;

                    sessionStorage.setItem('isUserLoggedMM',
                        JSON.stringify(sesionStorage)
                    )

                    this.setState({
                        stareHaslo: '',
                        noweHaslo: '',
                        powNoweHaslo: '',
                        zapisywanie: false
                    })

                    //window.location.reload();

                    //@ts-ignore
                    //this.zalogujPonownie(this.state.user.email,this.state.noweHaslo);

                }
            }).catch((error) => {
            //this.setState({registerLoading: false})
            //alert(error.response.data.message);
            this.setState({zapisywanie: false});
            notify.error(error.response.data.message, 'Błąd zmiany hasła');
            console.log('Zmiana hasla error');
        })
    }

    // onChangeSklep = (e: any) => {
    //     //@ts-ignore
    //     console.log(e.target.value, this.state.user.kraj, this.state.user.id);
    //
    //     //@ts-ignore
    //     Services.putKlientSklep(this.state.user.id, this.state.user.kraj, e.target.value)
    //         .then((response) => {
    //             if (response.status >= 200 && response.status <= 300) {
    //
    //                 //this.setState({onRegister: true, registerLoading: false})
    //                 console.log("Zmiana Sklepu ok");
    //                 NotificationManager.info("Pomyślnie zmieniono twój sklep", 'Zmieniono sklep', 5000);
    //
    //                 this.pobierzKlient();
    //
    //             }
    //         }).catch((error) => {
    //         //this.setState({registerLoading: false})
    //         //alert(error.response.data.message);
    //         NotificationManager.error(error.response.data.message, 'Błąd zmiany sklepu', 5000);
    //         console.log('Zmiana Sklepu error');
    //     })
    // }

    aktualizujDane = () => {
        let user = this.state.user;
        let userId = user.id;
        let dane = {
            "imie": user.imie,
            "nazwisko": user.nazwisko,
            "telefon": user.telefon,
            "kodPocztowy": user.kodPocztowy,
            "miejscowosc": user.miejscowosc,
            "ulica": user.ulica,
            "nrDomu": user.nrDomu,
            "nrMieszkania": user.nrMieszkania,
            "firma": user.firma,
            "firma2": user.firma2,
            "czyFirma": this.state.czyFirma
        }

        console.log(dane)

        Services.aktualizujDane(dane).then((response) => {
            this.setState({isEdit: false});
            notify.info("Pomyślnie zaktualizowano dane konta", 'Zaktualizowano dane');
        }).catch((e) => {
            notify.error(e.response.data.message, 'Błąd aktualizacji danych');
        })
    }

    closeForm = () => {
        this.setState({showUsunKonto: false, haslo: ''});
    }

    // onChangeInput = (key: string, value: string) => {
    //     // this.setState({[key]: value});
    // };

    render() {

        let {user, stareHaslo, noweHaslo, powNoweHaslo, isEdit, loading, czyFirma, zapisywanie, showUsunKonto, usuwanieKonta, bladNowegoHasla, bladPowtorzenia} = this.state;
        const lab = 'col-sm-3';
        const pole = 'col-sm-8';

        return <section id={'account'}>
            <h1 className={'h3'}>Moje konto</h1>

            {(loading) ?
                <p className={'h5'} role={'status'}>Ładowanie...</p>
                :
                <div className={'register-form'}>
                    <RequiredLegend/>
                    {(czyFirma) ?
                        <div className={'row mt-4'}>
                            <FormField label={'Email:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.email} name={'email'} autoComplete={'email'} disabled/>
                            </FormField>
                            <div className={'col-sm-1'}/>
                            <FormField label={'Firma:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.firma} onChange={this.handleOnChange} name={'firma'} autoComplete={'organization'}/>
                            </FormField>
                            <div className={'col-sm-1'}/>
                            <FormField label={'Firma cd:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.firma2} onChange={this.handleOnChange} name={'firma2'}/>
                            </FormField>
                            <FormField label={'Nip:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.nrIdent} name={'nrIdent'} disabled/>
                            </FormField>
                            <FormField label={'Kraj:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.kraj} name={'kraj'} disabled/>
                            </FormField>
                            <FormField label={'Telefon:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.telefon} onChange={this.handleOnChange} name={'telefon'} autoComplete={'tel'}/>
                            </FormField>
                            <div className={'col-sm-1'}/>
                            <FormField label={'Kod pocztowy:'} labelCol={'col-sm-3'} fieldCol={'col-sm-2'}>
                                <InputMask mask={[/\d/, /\d/, '-', /\d/, /\d/, /\d/]} className={'form-control'} style={{maxWidth: '90px', marginBottom: '10px'}}
                                           value={user.kodPocztowy} onChange={this.handleOnChange} name={'kodPocztowy'} autoComplete={'postal-code'}/>
                            </FormField>
                            <FormField label={'Miasto:'} labelCol={'col-sm-2'} fieldCol={'col-sm-4'}>
                                <input type={'text'} className={'form-control'} value={user.miejscowosc} onChange={this.handleOnChange} name={'miejscowosc'} autoComplete={'address-level2'}/>
                            </FormField>
                            <div className={'col-sm-1'}/>
                            <FormField label={'Nazwa Ulicy:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.ulica} onChange={this.handleOnChange} name={'ulica'} autoComplete={'address-line1'}/>
                            </FormField>
                            <FormField label={'Nr domu:'} required labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}} value={user.nrDomu} onChange={this.handleOnChange} name={'nrDomu'}/>
                            </FormField>
                            <FormField label={'Nr mieszkania:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}} value={user.nrMieszkania} onChange={this.handleOnChange} name={'nrMieszkania'}/>
                            </FormField>
                            <div className={'col-sm-1'}/>
                            <div className={'col-sm-12 text-right mt-4'}>
                                <button disabled={!isEdit} onClick={this.aktualizujDane} className={'btn btn-custom-secondary'}>Aktualizuj dane</button>
                            </div>
                        </div>
                        :
                        <div className={'row mt-4'}>
                            <FormField label={'Imię:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.imie} onChange={this.handleOnChange} name={'imie'} autoComplete={'given-name'}/>
                            </FormField>
                            <FormField label={'Nazwisko:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.nazwisko} onChange={this.handleOnChange} name={'nazwisko'} autoComplete={'family-name'}/>
                            </FormField>
                            <div className={'col-sm-1'}/>
                            <FormField label={'Kod pocztowy:'} labelCol={'col-sm-3'} fieldCol={'col-sm-2'}>
                                <InputMask mask={[/\d/, /\d/, '-', /\d/, /\d/, /\d/]} className={'form-control'} style={{maxWidth: '90px', marginBottom: '10px'}}
                                           value={user.kodPocztowy} onChange={this.handleOnChange} name={'kodPocztowy'} autoComplete={'postal-code'}/>
                            </FormField>
                            <FormField label={'Miasto:'} labelCol={'col-sm-2'} fieldCol={'col-sm-4'}>
                                <input type={'text'} className={'form-control'} value={user.miejscowosc} onChange={this.handleOnChange} name={'miejscowosc'} autoComplete={'address-level2'}/>
                            </FormField>
                            <div className={'col-sm-1'}/>
                            <FormField label={'Ulica:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.ulica} onChange={this.handleOnChange} name={'ulica'} autoComplete={'address-line1'}/>
                            </FormField>
                            <FormField label={'Nr domu:'} required labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}} value={user.nrDomu} onChange={this.handleOnChange} name={'nrDomu'}/>
                            </FormField>
                            <FormField label={'Nr mieszkania:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}} value={user.nrMieszkania} onChange={this.handleOnChange} name={'nrMieszkania'}/>
                            </FormField>
                            <FormField label={'Telefon:'} labelCol={lab} fieldCol={pole}>
                                <input type={'text'} className={'form-control'} value={user.telefon} onChange={this.handleOnChange} name={'telefon'} autoComplete={'tel'}/>
                            </FormField>
                            <div className={'col-sm-1'}/>
                            <div className={'col-sm-12 text-right mt-4'}>
                                <button disabled={!isEdit} onClick={this.aktualizujDane} className={'btn btn-custom-secondary'}>Aktualizuj dane</button>
                            </div>
                        </div>
                    }
                    <hr/>
                    <h2 className={'h3'}>Zmiana hasła</h2>
                    <div className={'row mt-4'} ref={this.zmianaHaslaRef}>
                        <FormField label={'Stare hasło:'} labelCol={lab} fieldCol={pole}>
                            <input type={'password'} className={'form-control'} value={stareHaslo} autoComplete={'current-password'}
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({stareHaslo: e.target.value})}/>
                        </FormField>
                        <FormField label={'Nowe hasło:'} labelCol={lab} fieldCol={pole} hint={WYMAGANIA_HASLA} error={bladNowegoHasla}>
                            <input type={'password'} className={'form-control'} value={noweHaslo} autoComplete={'new-password'}
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({noweHaslo: e.target.value, bladNowegoHasla: null})}/>
                        </FormField>
                        <FormField label={'Powtórz nowe hasło:'} labelCol={lab} fieldCol={pole} error={bladPowtorzenia}>
                            <input type={'password'} className={'form-control'} value={powNoweHaslo} autoComplete={'new-password'}
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({powNoweHaslo: e.target.value, bladPowtorzenia: null})}/>
                        </FormField>
                        <div className={'col-sm-12 text-right mt-4'}>
                            <button disabled={zapisywanie} onClick={this.zmienHaslo} className={'btn btn-custom-secondary'}>{(zapisywanie) ? <><i className="fa fa-spinner fa-spin" aria-hidden={'true'}/> zapisywanie...</> : 'Zmień hasło'}</button>
                        </div>
                    </div>

                    <hr/>

                    <Modal show={showUsunKonto} onHide={this.closeForm} aria-labelledby={'usun-konto-tytul'}>
                        <Modal.Header>
                            <Modal.Title id={'usun-konto-tytul'}>Usuwanie konta</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group controlId={'usun-konto-haslo'}>
                                <Form.Label>Aby usunąć konto wprowadź hasło do konta:</Form.Label>
                                <Form.Control
                                    type="password"
                                    autoComplete="current-password"
                                    placeholder="Wpisz hasło do konta..."
                                    autoFocus
                                    onChange={(e) => this.setState({haslo: e.target.value})}
                                />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.closeForm}>
                                Anuluj
                            </Button>
                            <Button variant="primary" onClick={this.usunKonto} disabled={usuwanieKonta}>
                                Usuń konto
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </section>
    }



}

export default Account;

